import { render } from "./CreateVideoToRoblox.vue?vue&type=template&id=e9145c3e"
const script = {}

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__